import * as types from "./mutation-types";
import * as dashboardTypes from "../dashboard/mutation-types";

export const fetchPOs = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders`, { params })
      .then(response => {
        commit(types.SET_POS, response.data.purchaseOrders.data);
        commit(types.SET_TOTAL_POS, response.data.purchaseOrders.total);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getRecord = ({ commit, dispatch, state }, record) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/records?record=${record}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCreatePO = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/create`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCreatePOForFinancing = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/po-prepaymentRequest/create`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchPO = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/${id}/edit`)
      .then(response => {
        commit(
          types.SET_TEMPLATE_ID,
          response.data.purchaseOrder.purchase_order_template_id
        );
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchViewPO = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendEmail = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/send`, data)
      .then(response => {
        if (response.data.success) {
          commit(types.UPDATE_PO_STATUS, { id: data.id, status: "SENT" });
          // commit('dashboard/' + dashboardTypes.UPDATE_PO_STATUS, { id: data.id, status: 'SENT' }, { root: true })
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addPO = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post("/api/purchaseOrders", data)
      .then(response => {
        // commit(types.ADD_PO, response.data.estimate)

        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deletePO = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .delete(`/api/purchaseOrders/${id}`)
      .then(response => {
        commit(types.DELETE_PO, id);
        // commit('dashboard/' + dashboardTypes.DELETE_PO, id, { root: true })
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteMultiplePOs = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/delete`, {
        purchase_order_ids: state.selectedPOs
      })
      .then(response => {
        commit(types.DELETE_MULTIPLE_POS, state.selectedPOs);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updatePO = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .put(`/api/purchaseOrders/${data.id}`, data)
      .then(response => {
        //commit(types.UPDATE_PO, response.data)
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const markAsAccepted = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/accept`, data)
      .then(response => {
        // commit('dashboard/' + dashboardTypes.UPDATE_PO_STATUS, { id: data.id, status: 'ACCEPTED' }, { root: true })
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const markAsRejected = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/reject`, data)
      .then(response => {
        // commit('dashboard/' + dashboardTypes.UPDATE_PO_STATUS, { id: data.id, status: 'REJECTED' }, { root: true })
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const markAsSent = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/mark-as-sent`, data)
      .then(response => {
        commit(types.UPDATE_PO_STATUS, { id: data.id, status: "SENT" });
        // commit('dashboard/' + dashboardTypes.UPDATE_PO_STATUS, { id: data.id, status: 'SENT' }, { root: true })
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const markAsClose = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/mark-as-closed`, data)
      .then(response => {
        commit(types.UPDATE_PO_STATUS, { id: data.id, status: "CLOSED" });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const convertToInvoice = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/${id}/convert-to-invoice`)
      .then(response => {
        // commit(types.UPDATE_INVOICE, response.data)
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const convertToDeliveryNote = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/convert-to-deliveryNote`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const searchPO = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders?${data}`)
      .then(response => {
        // commit(types.UPDATE_INVOICE, response.data)
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const selectPO = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_POS, data);
  if (state.selectedPOs.length === state.POs.length) {
    commit(types.SET_SELECT_ALL_STATE, true);
  } else {
    commit(types.SET_SELECT_ALL_STATE, false);
  }
};

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data);
};
export const setPOForDeliveryNotes = ({ commit, dispatch, state }, data) => {
  commit(types.SET_PO_FOR_DELIVERYNOTES, data);
};
export const setPOForInvoices = ({ commit, dispatch, state }, data) => {
  commit(types.SET_PO_FOR_INVOICES, data);
};
export const resetPOForInvoices = ({ commit, dispatch, state }) => {
  commit(types.RESET_PO_FOR_INVOICES);
};

export const selectAllPOs = ({ commit, dispatch, state }) => {
  if (state.selectedPOs.length === state.POs.length) {
    commit(types.SET_SELECTED_POS, []);
    commit(types.SET_SELECT_ALL_STATE, false);
  } else {
    let allPOIds = state.POs.map(po => po.id);
    commit(types.SET_SELECTED_POS, allPOIds);
    commit(types.SET_SELECT_ALL_STATE, true);
  }
};

export const resetSelectedPOs = ({ commit, dispatch, state }) => {
  commit(types.RESET_SELECTED_POS);
};

export const setSupplier = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_SUPPLIER);
  commit(types.SET_SUPPLIER, data);
};

export const setItem = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_ITEM);
  commit(types.SET_ITEM, data);
};

export const resetSupplier = ({ commit, dispatch, state }) => {
  commit(types.RESET_SUPPLIER);
};

export const resetItem = ({ commit, dispatch, state }) => {
  commit(types.RESET_ITEM);
};

export const setTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    console.log(data);
    commit(types.SET_TEMPLATE_ID, data);
    resolve({});
  });
};

export const selectSupplier = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/suppliers/${id}`)
      .then(response => {
        commit(types.RESET_SELECTED_SUPPLIER);
        commit(types.SELECT_SUPPLIER, response.data.supplier);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const resetSelectedSupplier = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_SELECTED_SUPPLIER);
};
export const SinglePOArray = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/singlePOArray/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchPurchaseOrderShow = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/purchaseOrders/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const importPO = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/purchaseOrders/importPO`, data)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
